import axios from "axios";
import ImagesUpload from "./ImagesUpload";
import { useState } from "react";
import { ImvFieldData } from "./assets/ImvFieldData";

export default function ImvReg() {
  const [formData, setFormData] = useState({
    nreg: '',
    cep: '',
    end: '',
    bairro: '',
    num: '',
    preco: '',
    quartos: '',
    banheiros: '',
    garagem: '',
    acc_pets: false,
    area: '',
    cond: '',
    tipo: '',
    status: '',
    descricao: '',
  });


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const cepAutoSearch = (cep) => {
    const url = `https://viacep.com.br/ws/${cep}/json`;

    setTimeout(async () => {
      try {
        const response = await axios.get(url);
        setFormData((prevData) => ({
          ...prevData,
          end: response.data.logradouro,
          bairro: response.data.bairro,
        }));
      } catch (error) {
        window.alert('Erro ao pesquisar CEP');
      }
    }, 2000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post('https://oxx-api.vercel.app/faiimoveis_/imoveis/', formData, {
        headers: {
          'api-key': 'xUp2jAz5hQZM#wCsKb',
          'content-type': 'multipart/form-data'
        }
      });
      alert('Imóvel cadastrado com sucesso!');
      setFormData({
        nreg: '',
        end: '',
        preco: '',
        quartos: '',
        banheiros: '',
        garagem: '',
        acc_pets: '',
        area: '',
        cond: '',
        tipo: '',
        status: '',
        descricao: '',
      });
    } catch (error) {
      console.error('Ocorreu um erro ao cadastrar o imóvel. Tente novamente.', error);
      alert('Ocorreu um erro ao cadastrar o imóvel. Tente novamente.');
    }
  };

  return (
    //* Formulário de Registro de Imóvel 
    <form className="text-black w-2/3 max-xl:w-full mx-auto my-24 p-8 rounded-xl shadow-black shadow-2xl bg-[#4141410c]"
      onSubmit={handleSubmit}
    >
      <h1 className="text-center text-white text-4xl font-thin mb-10"> Cadastrar Novo Imovel </h1>
      <section className="flex max-sm:block justify-stretch gap-5">
        <article className="w-full">
          {Object.entries(formData).map(([fieldName, fieldValue]) => (
            <div key={fieldName} className="mb-4">
              <label htmlFor={fieldName} className="block text-md font-thin text-white">
                {ImvFieldData[fieldName].label} {/* Nome Do Campo */}
              </label>
              <span className="flex">
                <input
                  type={ImvFieldData[fieldName].type}
                  id={fieldName}
                  name={fieldName}
                  placeholder={fieldName === 'cep' && 'Digite o CEP'}
                  value={formData[fieldName]}
                  onChange={(e) => setFormData((prevData) => ({ ...prevData, [fieldName]: e.target.value }))}
                  className="mt-1 block w-full border border-gray-300 p-2 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />

                {/* Espaço para Botao de Pesquisa ao Lado do Campo CEP */}
                {fieldName === 'cep' &&
                  <div className="bg-green-600 text-white grid rounded-md px-3 items-center text-center transition hover:cursor-pointer hover:bg-green-500"
                    onClick={() => cepAutoSearch(formData.cep)}>
                    Pesquisar
                  </div>}
              </span>
            </div>
          ))}
        </article>
        <article className="w-full">
          <ImagesUpload nreg={formData.nreg} />
        </article>
      </section>
      <button type="submit" className="mt-4 inline-flex items-center px-4 py-2 bg-indigo-500 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-indigo-700 active:bg-indigo-900 focus:outline-none focus:border-indigo-900 focus:ring focus:ring-indigo-300 transition">
        Cadastrar
      </button>
    </form>
  );
}
